import { useEffect, useState, useRef } from "react";

const SLOW_THRESHOLD = 1000 * 45; // 45 seconds

const useSlowQueryDetection = (isFetching) => {
  const [isTakingLong, setIsTakingLong] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isFetching) {
      // Start a timer when fetching begins
      timerRef.current = setTimeout(() => {
        setIsTakingLong(true);
      }, SLOW_THRESHOLD);
    } else {
      // Clear the timer and reset state when fetching finishes
      clearTimeout(timerRef.current);
      setIsTakingLong(false);
    }

    // Cleanup function to clear the timer if the component unmounts or isFetching changes
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [isFetching]);

  return isTakingLong;
};

export default useSlowQueryDetection;
